import { SVGIcon } from "@progress/kendo-angular-icons";

export function generateSvgString(icon: SVGIcon): string {
  return `<svg style="height: 16px; width: 16px;" viewBox="${icon.viewBox}">${icon.content}</svg>`;
}

export function generateSvgStringWithOverlay(icon: SVGIcon, overlayIcon: SVGIcon, overlaySettings: { bgColor?: string, scale?: number, position?: 'center' | 'bottomRight' } = {}): string {
  const overlayBgColor = overlaySettings.bgColor || "white";
  const overlayScale = overlaySettings.scale || 0.5;
  const position = overlaySettings.position || 'bottomRight';
  const viewBoxSize = +icon.viewBox.split(' ')[2];
  const translate = viewBoxSize * (1 - overlayScale) / (position === 'bottomRight' ? 1 : 2);
  return `<svg style="height: 16px; width: 16px;" viewBox="${icon.viewBox}">${icon.content}<g transform="translate(${translate}, ${translate}) scale(${overlayScale})"><rect x="0" y="0" width="512" height="512" fill="${overlayBgColor}"/>${overlayIcon.content}</g></svg>`;
}